import React, { Component } from 'react';
import  { BrowserRouter, Route, Switch} from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import './App.css';

// Import pages for display
import Homepage from './containers/Homepage/Homepage';
import ContactUs from './containers/ContactUs/ContactUs';
import Stotte from './containers/Stotte/Stotte';
import Timetable from './containers/Timetable/Timetable';

class App extends Component {
  render() {
    return (
      <div className="App">
          <BrowserRouter>
              <div className='all-content'>
                  <Header/>
                  <div className="page-content">
                      <Switch>
                          <Route path='/' exact component={Homepage} basename={process.env.PUBLIC_URL}/>
                          <Route path='/kontakt' component={ContactUs} />
                          <Route path='/stott-oss' component={Stotte} />
                          <Route path='/apningstider' component={Timetable} />
                      </Switch>
                  </div>
              </div>
          </BrowserRouter>
          <Footer/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js